import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { LenderAvailability, UpdateLenderAvailability } from '@thro-types/leihbar';

import { AxiosRequestConfig } from 'axios';

import { getLenderAvailability, updateOrCreateLenderAvailability } from 'api/leihbar';

export const useLenderAvailabilityQuery = (id: number, config?: AxiosRequestConfig) => {
  const query = useQuery<LenderAvailability, Error>({
    queryKey: ['lenderAvailability', id, config ? JSON.stringify(config.params) : ''],
    queryFn: () => {
      return getLenderAvailability(id, config);
    }
  });

  return query;
};

export const useLenderAvailabilityMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['lenderAvailability'];

  const update = useMutation<
    LenderAvailability,
    Error,
    { id: number; data: UpdateLenderAvailability }
  >({
    mutationFn: async args => {
      return await updateOrCreateLenderAvailability(args.id, args.data, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });
  return { update } as const;
};
